import { Component, Input } from '@angular/core';
import { LoadingIconButtonComponent } from '@app-components/common/loading-icon-button/loading-icon-button.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatMenuItem } from '@angular/material/menu';

@Component({
  selector: 'app-download-eml-button',
  templateUrl: './download-eml-button.component.html',
  styleUrls: ['./download-eml-button.component.scss'],
  imports: [LoadingIconButtonComponent, TranslateModule, MatMenuItem],
})
export class DownloadEmlButtonComponent {
  @Input() isMenu = false;
  @Input() showButton: boolean;
  @Input() showLoading: boolean;

  constructor() {}
}
